import { render, staticRenderFns } from "./FormLoginAsPartner.vue?vue&type=template&id=4e1eb272&"
import script from "./FormLoginAsPartner.vue?vue&type=script&lang=ts&"
export * from "./FormLoginAsPartner.vue?vue&type=script&lang=ts&"
import style0 from "./FormLoginAsPartner.vue?vue&type=style&index=0&id=4e1eb272&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports